















































import Tab from '@/components/general/Tab.vue';
import { ICategory, IRootCategory } from '@/contract/category.contract';
import { INamedGroup } from '@/contract/named-group.contract';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    Tab,
  },
})
export default class SearchCategoriesDesktop extends Vue {
  @Prop()
  public rootCategories!: IRootCategory[];

  public activeRoot: IRootCategory | null = null;

  private nbOfColumns = 4;

  public mounted() {
    // TODO: find better solution for this
    window.addEventListener('resize', () => {
      this.setNumberOfColumns();
    });
    this.setNumberOfColumns();
  }

  public divideGroups(category: IRootCategory): Array<Array<INamedGroup<ICategory>>> {
    const children = category.children || [];
    if (this.nbOfColumns === 1) {
      return [children];
    }
    if (this.nbOfColumns >= children.length) {
      return children.map((g) => [g]);
    }

    // calculate the sizes of all different possible configurations and select the one with the smallest height
    const sizes = this.getSubsectionSize(category, this.nbOfColumns - 2, children.length);
    const config = sizes.sort((a, b) => a.maxColSize - b.maxColSize)[0];

    const result: Array<Array<INamedGroup<ICategory>>> = [];
    for (let i = 0; i < config.pointers.length; i++) {
      result.push(children.slice(config.pointers[i], config.pointers[i + 1] || children.length));
    }
    return result;
  }

  public handleCategorySelected(category: ICategory): void {
    this.$emit('category-selected', this.activeRoot, category);
    this.activeRoot = null;
  }

  public handleTabClick(category: IRootCategory): void {
    if (this.activeRoot === category) {
      this.activeRoot = null;
      return;
    }
    this.activeRoot = category;
  }

  public handleBackdropClick(): void {
    this.activeRoot = null;
  }

  @Watch('activeRoot')
  public onactiveRootChanged() {
    const cssClass = 'categories-open';
    if (this.activeRoot) {
      window.document.body.classList.add(cssClass);
    } else {
      window.document.body.classList.remove(cssClass);
    }
  }

  private setNumberOfColumns(): void {
    this.nbOfColumns = window.innerWidth < 992 ? 3 : 4;
  }

  private getGroupSize(group: INamedGroup<ICategory>): number {
    return (group.children?.length || 0) + 2.5;
  }

  private getGroupCollectionSize(groups: Array<INamedGroup<ICategory>>): number {
    return groups.map((g) => this.getGroupSize(g)).reduce((prev, curr) => prev + curr, 0);
  }

  /**
   * Divide the category groups in the root category subsections and calculate the size of each subsection
   */
  private getSubsectionSize(
    category: IRootCategory,
    start: number,
    max: number,
  ): Array<{ maxColSize: number; pointers: number[] }> {
    const result: Array<{ maxColSize: number; pointers: number[] }> = [];

    for (let i = start; i < max; i++) {
      const children = category.children || [];
      let subResults: Array<{ maxColSize: number; pointers: number[] }>;

      if (start === 0) {
        // stopping condition: if start === 0, no sections can come before this section
        // calculate the size of the section starting at 0 up until the current pointer
        subResults = [
          {
            maxColSize: this.getGroupCollectionSize(children.slice(0, i + 1)),
            pointers: [0],
          },
        ];
      } else {
        // calculate the max sizes and pointers of the sections before the current pointer
        subResults = this.getSubsectionSize(category, start - 1, i);
      }

      // calculate the size of the the current pointer up until the max
      const size = this.getGroupCollectionSize(children.slice(i + 1, max + 1));

      // combine the results of the variances in the sections before the current with the size of the current section
      for (const sub of subResults) {
        result.push({
          maxColSize: Math.max(size, sub.maxColSize),
          pointers: [...sub.pointers, i + 1],
        });
      }
    }

    return result;
  }
}
